const localization = {
    cannot_delete_default_language: '你已设置 {{languageTag}} 为你的默认语言，你无法删除默认语言。',
    invalid_translation_structure: '无效的数据格式，请检查你的输入并重试。',
};
export default Object.freeze(localization);
